/* eslint-disable indent */
import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import KTComponent from './metronic/core';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import KTLayout from './metronic/app/layouts/demo1.js';
import AppRoutes from './routes/AppRoutes';
import 'react-notifications/lib/notifications.css';
import './App.css';
import { AuthProvider } from './providers/AuthProvider.js';
import {
  API_BASE_URL,
  LOCAL_BASE_URL,
  DEV_BASE_URL,
  PREPROD_BASE_URL,
} from './utils/constant.utils';

const App = () => {
  useEffect(() => {
    const hostname = API_BASE_URL;
    let environment = '';

    switch (hostname) {
      case LOCAL_BASE_URL:
        environment = '- LOCAL';
        break;
      case DEV_BASE_URL:
        environment = '- DEV';
        break;
      case PREPROD_BASE_URL:
        environment = '- PREPROD';
        break;
      default:
        environment = '';
        break;
    }

    document.title = `Lucius ${environment}`;
  }, []);

  useEffect(() => {
    KTComponent.init();
    KTLayout.init();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <ToastContainer />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
